<div class="sub-header px-3">
</div>
<div class="search-container py-3 align-items-center d-flex row px-3 mb-1 pb-4">
    <div class="col-md-6 catalog-header d-flex px-3 py-1">
        <h5 class="mb-0 px-0">FedEx Org. code - Location Management</h5>
    </div>
</div>
<div style="height: 83vh;" class="row bg-white p-4 mt-3">
    <div class="row d-flex align-items-center justify-content-between">
    <div class="col-md-5 search-input-wrapper mb-4">
        <label class="form-label">Organization Code<span class="text-danger">*</span></label>
        <div class="col-md-12 d-flex flex-column mb-2 position-relative ">
            <nz-select   #multiSelectRef nzMode="tags" [(ngModel)]="orgCode" nzPlaceHolder="Enter Organization Code seperated by comma"
                [nzAllowClear]="true" [nzOpen]="false" [nzShowArrow]="false" [nzOptions]="[]"  (nzOnSearch)="onSearch($event)"
                [nzTokenSeparators]="[',']" (paste)="onPaste($event)"  >
            </nz-select>
            <span class="error-text" *ngIf="orgCode.length ==0 && inValidForm">
                Atleast one Organization Code value is required.
            </span>
            <ng-template #dropDownRender>
                <div class="d-flex justify-content-end p-2">
                    <button nz-button nzType="primary" class="ok-btn" (click)="closeSelect(multiSelectRef)">
                        Ok
                    </button>
                </div>
            </ng-template>
        </div>
    </div>
    <div class="col-md-5 search-input-wrapper mb-4">
        <label class="form-label">Location <span class="text-danger">*</span></label>
        <div class="col-md-12 d-flex flex-column mb-2 position-relative">
            <input style="height: 38px !important;" placeholder="Enter location" [(ngModel)]="location"
                class="form-control">
            <span class="error-text" *ngIf="inValidForm && !location">
                Location value is required.
            </span>
        </div>
    </div>
    <div class="col-md-2 d-flex flex-row">
        <button class="mr-10" (click)="inValidForm=false;orgCode=[];location=''" nz-button nzType="default">Reset</button>
        &nbsp;
        <button (click)="addFedexOrgCode()" nz-button nzType="primary" class="d-flex align-items-center"
            [nzSize]="'default'"><span nz-icon nzType="plus"></span>Add</button>
    </div>
    </div>
    <div class="px-2 mt-2 py-4 col-md-12 amd-list-container">
        <div class="col-md-12 px-2 searh-input-block d-flex align-items-center justify-content-between ">
            <div class="col-md-6">
                    <nz-input-group class="px-2 mr-2 search-input-group" style="width: 80%;height: 35px;"
                        nzSize="default" [nzSuffix]="suffixIconSearch">
                        <input type="text" class="py-1" nz-input placeholder="Search For Organization / Location Code"
                            (keydown.enter)="searchOrgCode(SearchText.value)" [(ngModel)]="searchText" nzAllowClear
                            #SearchText />
                        <span class="close-icon" (click)="SearchText.value = '';searchOrgCode('')" class="px-1" nz-icon
                            nzType="close-circle"></span>

                    </nz-input-group>
                    <ng-template #suffixIconSearch>
                        <span class="search-icon" (click)="searchOrgCode(SearchText.value)" nz-icon
                            nzType="search"></span>
                    </ng-template>
                </div>
            <ng-container>
                <button [disabled]="selectedList.length == 0" (click)="deleteSelected()" nz-button nzType="primary"
                    class="d-flex align-items-center mr-10" [nzSize]="'default'">
                    <span nz-icon nzType="delete"></span> Delete
                </button>
            </ng-container>
        </div>
        <ng-container>
            <app-data-grid [frontPagination]="false" (updateRow)="editRow($event)" (selectedRows)="selectedRow($event)" (deleteRow)="deleteFedexMapping($event)"
                [columns]="fedexColumns" [dataSet]="fedexOrgCodeList" (tableScroll)="onTableScroll($event)" [gridStyle]="'white'"></app-data-grid>
        </ng-container>
    </div>
</div>
<app-confirm-popup *ngIf="showModal" [title]="'Delete'" message="Are you sure to delete the selected FedEx Org-code - Location association(s)?" confirmText="Delete"
  [triggerModal]="showModal" [cancelText]="'Cancel'" (confirm)="updateFedexList(payLoadData)"
  (cancel)="showModal =false;"></app-confirm-popup>